import React from 'react';
import { get as _get } from 'lodash';

export default class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || props.defaultValue || '',
    };

    if (props.autofocus === true) {
      this.myInputRef = React.createRef();
    }
  }

  componentDidMount() {
    if (this.myInputRef && this.myInputRef.current) {
      this.myInputRef.current.focus();
    }
  }

  handleChange = (ev, returndisplay = false) => {
    const val = ev.target.value;
    this.setState({ value: val });
    this.props.onChange &&
      this.props.onChange(val, returndisplay ? ev.target.selectedOptions[0].text : null);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  renderOptions() {
    if (!this.props.options || !Array.isArray(this.props.options)) return [];
    return this.props.options.reduce((r, d, i, a) => {
      r.push(
        <option
          value={d.value}
          key={d.value || d.display}
          disabled={!!d.disabled}
          style={d.style || {}}
          onClick={(e) => (d.onClick ? d.onClick(e) : () => {})}
        >
          {d.display}
        </option>
      );
      return r;
    }, []);
  }

  getSelectFirstValue = () => {
    return _get(this.props, 'options[0].value', '');
  };

  render() {
    let { type, classNames } = this.props;
    if (!classNames) classNames = '';
    switch (type) {
      case 'textarea':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <label>{this.props.title}</label>
            <textarea
              {...this.props}
              onChange={this.handleChange}
              value={this.state.value}
              placeholder={this.props.placeholder || '...'}
            />
          </div>
        );

      case 'select':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <label>{this.props.title}</label>
            <select
              {...this.props}
              onChange={(e) => this.handleChange(e, this.props.returndisplay)}
              value={this.state.value || this.getSelectFirstValue()}
            >
              {this.renderOptions()}
            </select>
          </div>
        );

      case 'checkbox':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <input
              type="checkbox"
              {...this.props}
              onChange={this.props.onChange}
              value={this.state.value || false}
              defaultChecked={this.props.defaultChecked}
            />
            <label className="label-inline" htmlFor="confirmField">
              {this.props.title}
            </label>
          </div>
        );

      case 'switch':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <span className="switch-label">{this.props.title}</span>

            <label className="switch">
              <input
                type="checkbox"
                checked={this.props.checked}
                onChange={this.props.onChange}
                value={this.state.value}
                defaultChecked={this.props.defaultValue}
                disabled={this.props.disabled}
              />

              <span className="slider round"></span>
            </label>
          </div>
        );

      case 'switch-left':
        classNames = classNames || 'fieldWrapper';
        return (
          <div data-component="Input" className={'switch-left ' + classNames}>
            <label className="switch">
              <input
                type="checkbox"
                checked={this.props.checked}
                onChange={this.props.onChange}
                value={this.state.value}
                defaultChecked={this.props.defaultValue}
              />

              <span className="slider round"></span>
            </label>
            <span className="switch-label">{this.props.title}</span>
          </div>
        );

      case 'number':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <label>{this.props.title}</label>
            <input
              type="number"
              {...this.props}
              onChange={this.handleChange}
              value={this.state.value}
              min={this.props.min || 0}
              max={this.props.max || 2147483647}
            />
          </div>
        );

      case 'password':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <label>{this.props.title}</label>
            <input
              {...this.props}
              type="password"
              onChange={this.handleChange}
              value={this.state.value}
              placeholder={this.props.placeholder}
              onBlur={this.props.onBlur || (() => null)}
            />
          </div>
        );

      case 'file':
        return (
          <div data-component="Input" className={'fieldWrapper ' + classNames}>
            <label>{this.props.title}</label>
            <input
              {...this.props}
              type="file"
              onChange={(e) => this.props.onChange(e.target.files[0])}
              accept={this.props.accept}
            />
          </div>
        );
      case 'text':
      default:
        return (
          <div
            data-component="Input"
            className={`fieldWrapper ${
              this.props.showClear === true ? 'flx align_center ' : ' ' + classNames
            } ${this.props.noBottomMargin ? 'mb-0' : ''}`}
          >
            <label>{this.props.title}</label>
            <input
              {...this.props}
              ref={this.props.autofocus === true ? this.myInputRef : undefined}
              type={this.props.type || 'text'}
              style={{
                paddingRight: this.props.showClear === true ? '24px' : null,
                position: 'relative',
              }}
              onChange={this.handleChange}
              value={this.state.value}
              placeholder={this.props.placeholder}
              className={this.props.noBottomMargin ? 'mb-0' : ''}
            />
            {this.props.showClear === true && (
              <i
                style={{
                  color: '#24292c88',
                  position: 'absolute',
                  right: 8,
                  opacity: this.props.isClearShown ? 1 : 0,
                }}
                onClick={() => {
                  this.handleChange({ target: { value: '' } });
                  this.setState({ value: '' }, () => {
                    this.setState({ value: null });
                  });
                }}
                className="far fa-times-circle"
              ></i>
            )}
          </div>
        );
    }
  }
}
